import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NOTIFICATIONS_PATHS } from './notifications';
import { NotificationsListComponent } from './notifications-list/notifications-list.component';
import { AuthGuard } from '../auth/auth.guard.service';

const routes: Routes = [
  {
    path: NOTIFICATIONS_PATHS.notifications,
    component: NotificationsListComponent,
    canActivate: [AuthGuard],
    data: {
      animation: 'NotificationsPage',
      permission: 'notification.get',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NotificationsRoutingModule {}
